import script from "./XDropdown.vue?vue&type=script&lang=ts&setup=true"
export * from "./XDropdown.vue?vue&type=script&lang=ts&setup=true"

import "./XDropdown.vue?vue&type=style&index=0&id=131b5f96&lang=scss&scoped=true"

import exportComponent from "D:\\x1\\vue3-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-131b5f96"]])

export default __exports__